import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _createForOfIteratorHelper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/containerelement
 */
import Element from './element';
/**
 * Containers are elements which define document structure. They define boundaries for
 * {@link module:engine/view/attributeelement~AttributeElement attributes}. They are mostly used for block elements like `<p>` or `<div>`.
 *
 * Editing engine does not define a fixed HTML DTD. This is why a feature developer needs to choose between various
 * types (container element, {@link module:engine/view/attributeelement~AttributeElement attribute element},
 * {@link module:engine/view/emptyelement~EmptyElement empty element}, etc) when developing a feature.
 *
 * The container element should be your default choice when writing a converter, unless:
 *
 * * this element represents a model text attribute (then use {@link module:engine/view/attributeelement~AttributeElement}),
 * * this is an empty element like `<img>` (then use {@link module:engine/view/emptyelement~EmptyElement}),
 * * this is a root element,
 * * this is a nested editable element (then use  {@link module:engine/view/editableelement~EditableElement}).
 *
 * To create a new container element instance use the
 * {@link module:engine/view/downcastwriter~DowncastWriter#createContainerElement `DowncastWriter#createContainerElement()`}
 * method.
 *
 * @extends module:engine/view/element~Element
 */

var ContainerElement = /*#__PURE__*/function (_Element) {
  _inherits(ContainerElement, _Element);

  var _super = _createSuper(ContainerElement);

  /**
   * Creates a container element.
   *
   * @see module:engine/view/downcastwriter~DowncastWriter#createContainerElement
   * @see module:engine/view/element~Element
   * @protected
   */
  function ContainerElement(name, attrs, children) {
    var _this;

    _classCallCheck(this, ContainerElement);

    _this = _super.call(this, name, attrs, children);
    /**
     * Returns block {@link module:engine/view/filler filler} offset or `null` if block filler is not needed.
     *
     * @method #getFillerOffset
     * @returns {Number|null} Block filler offset or `null` if block filler is not needed.
     */

    _this.getFillerOffset = getFillerOffset;
    return _this;
  }
  /**
   * Checks whether this object is of the given.
   *
   *		containerElement.is( 'containerElement' ); // -> true
   *		containerElement.is( 'element' ); // -> true
   *		containerElement.is( 'node' ); // -> true
   *		containerElement.is( 'view:containerElement' ); // -> true
   *		containerElement.is( 'view:element' ); // -> true
   *		containerElement.is( 'view:node' ); // -> true
   *
   *		containerElement.is( 'model:element' ); // -> false
   *		containerElement.is( 'documentFragment' ); // -> false
   *
   * Assuming that the object being checked is a container element, you can also check its
   * {@link module:engine/view/containerelement~ContainerElement#name name}:
   *
   *		containerElement.is( 'div' ); // -> true if this is a div container element
   *		containerElement.is( 'contaienrElement', 'div' ); // -> same as above
   *		text.is( 'div' ); -> false
   *
   * {@link module:engine/view/node~Node#is Check the entire list of view objects} which implement the `is()` method.
   *
   * @param {String} type Type to check when `name` parameter is present.
   * Otherwise, it acts like the `name` parameter.
   * @param {String} [name] Element name.
   * @returns {Boolean}
   */


  _createClass(ContainerElement, [{
    key: "is",
    value: function is(type) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var cutType = type && type.replace(/^view:/, '');

      if (!name) {
        return cutType == 'containerElement' || _get(_getPrototypeOf(ContainerElement.prototype), "is", this).call(this, type);
      } else {
        return cutType == 'containerElement' && name == this.name || _get(_getPrototypeOf(ContainerElement.prototype), "is", this).call(this, type, name);
      }
    }
  }]);

  return ContainerElement;
}(Element);
/**
 * Returns block {@link module:engine/view/filler filler} offset or `null` if block filler is not needed.
 *
 * @returns {Number|null} Block filler offset or `null` if block filler is not needed.
 */


export { ContainerElement as default };
export function getFillerOffset() {
  var children = _toConsumableArray(this.getChildren());

  var lastChild = children[this.childCount - 1]; // Block filler is required after a `<br>` if it's the last element in its container. See #1422.

  if (lastChild && lastChild.is('element', 'br')) {
    return this.childCount;
  }

  var _iterator = _createForOfIteratorHelper(children),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;

      // If there's any non-UI element – don't render the bogus.
      if (!child.is('uiElement')) {
        return null;
      }
    } // If there are only UI elements – render the bogus at the end of the element.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return this.childCount;
}